import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/functions'
import 'firebase/messaging'
import 'firebase/storage'

// Initialize Firebase
const config = {
	apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
	authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
	databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
	projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
	appId: process.env.VUE_APP_FIREBASE_APP_ID,
	measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};
const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({})

export const db = firebaseApp.firestore()
export const auth = firebaseApp.auth()
export const storage = firebaseApp.storage()
let firebaseMessaging = null;

if(firebase.messaging.isSupported()){
	firebaseMessaging = firebaseApp.messaging();
	firebaseMessaging.usePublicVapidKey(process.env.VUE_APP_FIREBASE_MESSAGING_PUBLIC_KEY);
}
// export const authSession = firebase.auth.Auth.Persistence.SESSION
export const functions = firebase.functions();
export const messaging = firebaseMessaging;
